import { Input, Tooltip } from 'antd';
import oddsApi from 'api/oddsApi';
import { useAppDispatch, useAppSelector, useAppTranslation, useErrTranslation } from 'app/hooks';
import google_mic_icon from 'assets/icons/google_mic_icon.png';
import { showErrorModal } from 'components/Modals/CommonModals';
import { BetVoiceResponseModel } from 'models';
import React, { useEffect, useState } from 'react';
import useSpeechToText from 'react-hook-speech-to-text';
import { MdClear } from 'react-icons/md';
import { selectSearch, setGames, setSearch } from '../homeSlice';
import BetModal from './Modals/BetModal';
import ResizeableLoadingSpinner from 'components/Commons/ResizeableLoadingSpinner';
import { platformStates } from 'redux/platformSlice';
import bet_voice_icon from 'assets/icons/bet_voice_icon.png';
interface SearchItemProps {
  onSubmit: (value: string) => void;
}

const SearchItem: React.FunctionComponent<SearchItemProps> = ({ onSubmit }) => {
  const t = useAppTranslation();
  const et = useErrTranslation();
  const dispatch = useAppDispatch();
  const search = useAppSelector(selectSearch);
  const [searchText, setSearchText] = useState<string>('');
  const [isSearch, setIsSearch] = useState<boolean>(false);
  const [isSearchingBet, setIsSearchingBet] = useState<boolean>(false);
  const [gameBet, setGameBet] = useState<BetVoiceResponseModel | null>(null);
  const { isPhone } = useAppSelector(platformStates);
  const { isRecording, results, setResults, startSpeechToText, stopSpeechToText } = useSpeechToText(
    {
      continuous: false,
      useLegacyResults: false,
      googleApiKey: 'AIzaSyAeSHMbVsToD_ydi5FR7HQc_yuMMYdE49A',
      googleCloudRecognitionConfig: {
        languageCode: 'en-US',
        model: 'command_and_search',
      },
      useOnlyGoogleCloud: true,
    },
  );

  useEffect(() => {
    if (results && results.length && (results[0] as any).transcript !== '') {
      if (isSearch) {
        setSearchText((results[0] as any).transcript);
        dispatch(
          setSearch({
            isSearchLayout: true,
            searchText: (results[0] as any).transcript,
          }),
        );
      } else {
        searchBet((results[0] as any).transcript);
      }
      setIsSearch(isSearch);
    }
  }, [dispatch, results]);

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(event.target.value);
  };

  const listenContinuously = (isSearch: boolean) => {
    if (isRecording) return;
    setResults([]);
    setIsSearch(isSearch);
    startSpeechToText();
  };

  const resetSearch = () => {
    setSearchText('');
    dispatch(
      setSearch({
        searchText: '',
        isSearchLayout: false,
      }),
    );
    dispatch(setGames(undefined));
  };

  const cancelListen = () => {
    stopSpeechToText();
    setIsSearch(false);
  };

  const searchBet = async (search: string) => {
    if (search && search !== '') {
      setIsSearchingBet(true);
      const { ok, body, error } = await oddsApi.voiceBet({
        message: search,
        gameId: null,
      });
      setIsSearchingBet(false);
      if (ok && body) {
        setGameBet(body);
      }
      if (error) {
        const onOk = () => {};
        showErrorModal({
          content:
            error.message === 'Invalid request body'
              ? et('error.validate.message.required')
              : et(error.message),
          onOk,
          title: et(error.title || '', { defaultValue: et('defaultMessage.title') }),
        });
      }
      resetSearch();
    }
  };

  const closeModal = () => {
    setGameBet(null);
    resetSearch();
  };

  const searchBetTooltip = (
    <span className="row-infor__right span text-white" style={{ fontSize: '10px' }}>
      {t('common.bet-voice')}
    </span>
  );

  return (
    <>
      <Input
        placeholder={t('common.search')}
        className="search-input"
        prefix={
          <div className="flex-row items-center gap-2">
            {isRecording ? (
              <div className="">
                {isSearch ? (
                  <img
                    onClick={cancelListen}
                    src={google_mic_icon}
                    alt="bet-icon"
                    className="w-5 h-5 cursor-pointer"
                  />
                ) : (
                  <img
                    onClick={cancelListen}
                    src={google_mic_icon}
                    alt="bet-icon"
                    className="w-5 h-5 cursor-pointer"
                  />
                )}
              </div>
            ) : (
              <div className="flex-row items-center gap-2">
                {search.searchText && <MdClear onClick={resetSearch} className="search__icon" />}
                <img
                  onClick={() => listenContinuously(true)}
                  src={google_mic_icon}
                  alt="search__icon"
                  className="w-5 h-5 cursor-pointer"
                />
              </div>
            )}
          </div>
        }
        value={searchText}
        onChange={onChange}
        onPressEnter={() => onSubmit(searchText)}
        suffix={
          isRecording ? (
            <div className="flex-row items-center gap-2">
              <Tooltip placement={isPhone ? 'bottom' : 'rightTop'} title={searchBetTooltip}>
                <img
                  onClick={cancelListen}
                  src={bet_voice_icon}
                  alt="bet-icon"
                  className="w-5 h-5 cursor-pointer"
                />
              </Tooltip>
            </div>
          ) : (
            <div className="flex-row items-center gap-2">
              {isSearchingBet ? (
                <ResizeableLoadingSpinner size="md" />
              ) : (
                <Tooltip placement={isPhone ? 'bottom' : 'rightTop'} title={searchBetTooltip}>
                  <img
                    src={bet_voice_icon}
                    onClick={() => listenContinuously(false)}
                    alt="bet-icon"
                    className="w-5 h-5 cursor-pointer"
                  />
                </Tooltip>
              )}
            </div>
          )
        }
      />
      {gameBet && (
        <BetModal
          className="common-modal deposit-modal"
          title={t('bet.placeBet')}
          visible={true}
          closeModal={closeModal}
          bet={gameBet}
        />
      )}
    </>
  );
};

export default SearchItem;
